import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.deploy');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Chart } from 'chart.js/auto';

@Component({
    selector: 'wiz-page-deploy',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.deploy/view.scss */
/* src/app/page.deploy/view.scss: no such file or directory */`],
})
export class PageDeployComponent implements OnInit {
    @ViewChild('healthChartCanvas') healthChartCanvas!: ElementRef<HTMLCanvasElement>;

    public list: any = [];
    public loading: boolean = true;
    public checking: boolean = false;
    public healthProgress: any = { current: 0, total: 0, name: '', percent: 0, healthy: 0, unhealthy: 0 };
    public search: any = { status: '', health: '', project_id: '' };
    public pagination: any = { current: 1, start: 0, end: 0 };

    // Project filter
    public projects: any[] = [];

    // Health History Modal
    public showHealthModal: boolean = false;
    public healthModalItem: any = null;
    public healthPeriod: string = '1w';
    public healthCustomStart: string = '';
    public healthCustomEnd: string = '';
    public healthChartData: any[] = [];
    public healthChartLoading: boolean = false;
    private healthChart: Chart | null = null;

    public periodOptions = [
        { value: '3h', label: '3시간' },
        { value: '6h', label: '6시간' },
        { value: '12h', label: '12시간' },
        { value: '1d', label: '1일' },
        { value: '3d', label: '3일' },
        { value: '1w', label: '1주' },
        { value: '1m', label: '1개월' },
        { value: '6m', label: '6개월' },
        { value: '1y', label: '1년' },
        { value: 'custom', label: '기간 선택' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadProjects();
        await this.load();
    }

    public async loadProjects() {
        const { code, data } = await wiz.call("projects");
        if (code === 200) {
            this.projects = data.rows || [];
        }
    }

    public async onProjectChange(value: string) {
        this.search.project_id = value;
        await this.load();
    }

    public async load(page: number = 1) {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("search", {
            status: this.search.status,
            health: this.search.health,
            project_id: this.search.project_id,
            page: page,
            dump: 50,
        });

        this.list = data.rows || [];
        const total = data.total || 0;
        const dump = data.dump || 50;
        const lastpage = Math.ceil(total / dump);
        this.pagination = {
            current: page,
            start: lastpage > 1 ? 1 : 0,
            end: lastpage
        };

        this.loading = false;
        await this.service.render();
    }

    public statusBadgeClass(status: string) {
        if (status === 'running') {
            return 'inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20';
        }
        return 'inline-flex items-center rounded-full bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10';
    }

    public healthBadgeClass(health: string) {
        if (health === 'healthy') {
            return 'inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20';
        }
        if (health === 'unhealthy') {
            return 'inline-flex items-center rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20';
        }
        if (health === 'error') {
            return 'inline-flex items-center rounded-full bg-yellow-50 px-2 py-0.5 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-600/20';
        }
        if (health === 'stop') {
            return 'inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500 ring-1 ring-inset ring-slate-400/20';
        }
        return 'inline-flex items-center rounded-full bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-400 ring-1 ring-inset ring-gray-500/10';
    }

    public formatDate(dateStr: string) {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    public async stop(item: any) {
        if (!await this.service.modal.error(`Are you sure stop '${item.name}'?`, `Cancel`, `Stop`)) return;
        this.service.status.show("loading");
        await wiz.call("stop", { project_id: item.project_id, deploy_id: item.id });
        this.service.status.hide("loading");
        await this.load(this.pagination.current);
    }

    public async start(item: any) {
        this.service.status.show("loading");
        const { code, data } = await wiz.call("start", { project_id: item.project_id, deploy_id: item.id });
        this.service.status.hide("loading");
        if (code != 200) {
            await this.service.modal.error(data, false, `Confirm`);
        }
        await this.load(this.pagination.current);
    }

    public async checkHealth() {
        this.checking = true;
        this.healthProgress = { current: 0, total: 0, name: '', percent: 0, healthy: 0, unhealthy: 0 };
        await this.service.render();

        const url = wiz.url('health');
        const eventSource = new EventSource(url);

        eventSource.onmessage = async (event: any) => {
            const info = JSON.parse(event.data);
            this.healthProgress.current = info.current;
            this.healthProgress.total = info.total;
            this.healthProgress.name = info.name;
            this.healthProgress.healthy = info.healthy || 0;
            this.healthProgress.unhealthy = info.unhealthy || 0;
            this.healthProgress.percent = info.total > 0 ? Math.round((info.current / info.total) * 100) : 0;
            await this.service.render();

            if (info.type === 'done') {
                eventSource.close();
                this.checking = false;
                await this.load(this.pagination.current);
                await this.service.render();
            }
        };

        eventSource.onerror = async () => {
            eventSource.close();
            this.checking = false;
            await this.load(this.pagination.current);
            await this.service.render();
        };
    }

    // Health History Modal
    public async openHealthHistory(item: any) {
        this.healthModalItem = item;
        this.showHealthModal = true;
        this.healthPeriod = '1w';
        this.healthCustomStart = '';
        this.healthCustomEnd = '';
        await this.service.render();
        await this.loadHealthHistory();
    }

    public closeHealthModal() {
        this.showHealthModal = false;
        this.healthModalItem = null;
        if (this.healthChart) {
            this.healthChart.destroy();
            this.healthChart = null;
        }
    }

    public async onPeriodChange() {
        if (this.healthPeriod !== 'custom') {
            await this.loadHealthHistory();
        }
    }

    public async applyCustomRange() {
        if (this.healthCustomStart && this.healthCustomEnd) {
            await this.loadHealthHistory();
        }
    }

    public async loadHealthHistory() {
        this.healthChartLoading = true;
        await this.service.render();

        const params: any = {
            deploy_id: this.healthModalItem.id,
            period: this.healthPeriod,
        };
        if (this.healthPeriod === 'custom' && this.healthCustomStart && this.healthCustomEnd) {
            params.start_date = this.healthCustomStart;
            params.end_date = this.healthCustomEnd;
        }

        const { code, data } = await wiz.call("health_history", params);
        this.healthChartData = code === 200 ? (data.rows || []) : [];
        this.healthChartLoading = false;
        await this.service.render();

        setTimeout(() => { this.renderHealthChart(); }, 100);
    }

    private renderHealthChart() {
        if (this.healthChart) {
            this.healthChart.destroy();
            this.healthChart = null;
        }

        const canvas = this.healthChartCanvas?.nativeElement;
        if (!canvas) return;

        const rows = this.healthChartData;
        if (rows.length === 0) return;

        const labels = rows.map((r: any) => r.checked_at);
        const values = rows.map((r: any) => r.status);

        // Build segment colors: green for healthy (2), red for unhealthy/error (1), gray for stop (0)
        const segmentColor = (ctx: any) => {
            const idx = ctx.p1DataIndex;
            const val = values[idx];
            if (val === 2) return 'rgba(34, 197, 94, 1)';
            if (val === 1) return 'rgba(239, 68, 68, 1)';
            return 'rgba(156, 163, 175, 1)';
        };

        const segmentBgColor = (ctx: any) => {
            const idx = ctx.p1DataIndex;
            const val = values[idx];
            if (val === 2) return 'rgba(34, 197, 94, 0.15)';
            if (val === 1) return 'rgba(239, 68, 68, 0.15)';
            return 'rgba(156, 163, 175, 0.08)';
        };

        const pointColors = values.map((v: number) => {
            if (v === 2) return 'rgba(34, 197, 94, 1)';
            if (v === 1) return 'rgba(239, 68, 68, 1)';
            return 'rgba(156, 163, 175, 1)';
        });

        this.healthChart = new Chart(canvas, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Health Status',
                    data: values,
                    borderColor: pointColors,
                    backgroundColor: pointColors.map((c: string) => c.replace(', 1)', ', 0.15)')),
                    segment: {
                        borderColor: segmentColor,
                        backgroundColor: segmentBgColor,
                    },
                    fill: true,
                    tension: 0.3,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    borderWidth: 2,
                    stepped: 'before',
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: (items: any) => {
                                return items[0]?.label || '';
                            },
                            label: (item: any) => {
                                const v = item.raw;
                                if (v === 2) return 'Healthy';
                                if (v === 1) return 'Unhealthy / Error';
                                return 'Stop';
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            maxTicksLimit: 10,
                            callback: function(value: any, index: number) {
                                const label = labels[index];
                                if (!label) return '';
                                const d = new Date(label);
                                const pad = (n: number) => n.toString().padStart(2, '0');
                                return `${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
                            },
                            font: { size: 11 },
                            color: '#9ca3af',
                        },
                        grid: { display: false }
                    },
                    y: {
                        min: -0.2,
                        max: 2.5,
                        ticks: {
                            stepSize: 1,
                            callback: function(value: any) {
                                if (value === 0) return 'Stop';
                                if (value === 1) return 'Unhealthy';
                                if (value === 2) return 'Healthy';
                                return '';
                            },
                            font: { size: 11 },
                            color: '#9ca3af',
                        },
                        grid: {
                            color: 'rgba(0,0,0,0.05)',
                        }
                    }
                }
            }
        });
    }
}

export default PageDeployComponent;